import React, { Component } from 'react'
import { FormattedNumber } from 'react-intl'
import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import 'react-rangeslider/lib/index.css'
import Slider from 'react-rangeslider'

class InlineEditSlider extends Component {

    constructor(props, context) {
        super(props, context)

        this.state = {
            endPoint: this.props.endPoint || '',
            field: this.props.field || '',
            editable: this.props.editable || false,
            editMode: false,
            onChange: this.props.onChange || function () { },
            isLoading: false,
            min: this.props.min || 0,
            max: this.props.max || 100,
            step: this.props.step || 5,
            valuePercent: this.props.valuePercent || 0.1,
            className: this.props.className || '',
        }
        this.onSave = this.props.onSave || function () { }
        this.save = this.save.bind(this)
        this.handleSliderChange = this.handleSliderChange.bind(this)
        this.handleSliderChangeComplete = this.handleSliderChangeComplete.bind(this)
        const defaultCallback = () => { }
        this.onSave = this.props.onSave || defaultCallback
        this.onChange = this.props.onChange || defaultCallback
    }

    componentDidMount() {
        this.setState({
            value: this.state.valuePercent * this.state.max,
        })
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            endPoint: nextProps.endPoint || '',
            field: nextProps.field || '',
            min: nextProps.min || 0,
            max: nextProps.max || 100,
            step: nextProps.step || 5,
            valuePercent: nextProps.valuePercent || 0,
        }, () => {
            this.setState({
                value: this.state.valuePercent * this.state.max,
            })
        })
    }

    save() {
        this.setState({
            isLoading: true,
        })
        AppContext.getApiClient().patch(this.state.endPoint, {
            [this.state.field]: String(this.state.valuePercent),
        }).then((r) => {
            const attr = r.attributes || {}
            this.setState({
                value: attr[this.state.field] * this.state.max,
                editMode: false,
                isLoading: false,
            })
            this.onSave(this.state.valuePercent)
        })
    }

    handleSliderChange(value) {
        this.setState({
            value,
            valuePercent: value / this.state.max,
        }, () => {
            this.onChange(this.state.valuePercent)
        })
    }

    handleSliderChangeComplete() {
        this.save()
    }

    render() {
        return (
            <div className="row">
                <div className="col-1 pt-3">
                    <FormattedNumber
                        style="percent"
                        value={this.state.valuePercent}
                    />
                </div>
                <div className="col-11">
                    <Slider
                        className={this.state.className}
                        min={this.state.min}
                        max={this.state.max}
                        tooltip={false}
                        value={this.state.value}
                        onChange={this.handleSliderChange}
                        onChangeComplete={this.handleSliderChangeComplete}
                        disabled={true}
                        step={this.state.step}
                    />
                </div>
            </div>)
    }

}

export default InlineEditSlider





// WEBPACK FOOTER //
// ./src/common/inline-edit/slider.component.jsx